import { call } from '../core'

export interface ICallBrowser {
  url: string
}

export function callBrowser(param: ICallBrowser) {
  return call('finCallBrowser', param)
}
